<template>
  <BaseSelect :value="value"
              :options="items"
              :placeholder="$tFilter('All areas')"
              textKey="title"
              cancelable
              :filterable="false"
              :loading="loading"
              @input="onInput"/>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        timer: null
      }
    },
    computed: {
      items() {
        return this.$store.state.filter.directionsList || []
      },
      loading() {
        return this.$store.state.filter.pendingDirections
      }
    },
    methods: {
      // load(search, toggleLoading) {
      //   if (toggleLoading) toggleLoading(true)
      //   this.pending = true
      //   if (this.cancel) this.cancel()
      //
      //   http.get(`/api/vacancies/directions-list?search_query=${search}`, {
      //     cancelToken: new CancelToken((c) => this.cancel = c)
      //   }).then(({data}) => {
      //     this.items = data.data
      //   }).finally(() => {
      //     this.pending = false
      //     if (toggleLoading) toggleLoading(false)
      //   })
      // },
      // onSearch(search, toggleLoading) {
      //   clearTimeout(this.timer)
      //   this.timer = setTimeout(() => {
      //     this.load(search, toggleLoading)
      //   }, 300)
      // },
      onInput(value) {
        this.$emit('input', value)
      }
    },
    created() {
      this.$store.dispatch('filter/loadDirections').then(() => {
        this.$emit('loaded')
      })
    }
  }
</script>

<style lang="less">

</style>
